<template>
  <div>
    <div class="d-flex mb-3">
      <button
        class="btn btn-primary"
        :disabled="status.applied_at || applying"
        @click.prevent="apply()"
      >
        {{ status.applied_at ? 'Application Received' : 'Apply For Reimbursement' }}
      </button>
      <a
        v-if="help"
        :href="help"
        class="btn btn-link"
      >
        I need help
      </a>
    </div>
    <div
      v-if="status.applied_at"
      class="text-muted small"
    >
      You applied for Redwood Listing Rewards on {{ appliedAtDisplay }}.
    </div>
    <div
      v-if="error"
      class="text-danger small"
    >
      Oops! Something went wrong. We're working on it.
    </div>
  </div>
</template>

<script>
import { getListingReimbursementStatus, applyForListingReimbursement } from '@/api'
import { formatDate } from '@/lib/moment'

export default {
  props: {
    listing_id: {
      type: [String, Number],
      default: null,
      required: true,
    },
    help: {
      type: String,
      default: null,
    },
  },
  computed: {
    appliedAtDisplay () {
      return this.status.applied_at ? formatDate(this.status.applied_at, 'MMMM d, YYYY') : null
    }
  },
  data () {
    return {
      applying: false,
      error: false,
      status: {
        applied_at: null,
        api_response: null,
      },
    }
  },
  async mounted () {
    this.applying = true
    let response = await getListingReimbursementStatus(this.listing_id)
    this.status = response.data
    this.applying = false
  },
  methods: {
    async apply () {
      this.applying = true
      try {
        let response = await applyForListingReimbursement(this.listing_id)
        this.status = response.data
      } catch (e) {
        this.error = true
      }
      this.applying = false
    }
  }
}
</script>
